module.exports = __webpack_public_path__ + "img/h5l.6b0e71b1.svg";